import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const fixedFeeTermsTableHead: TableHeadItemRecurse[] = [
  { title: 'Termo', flex: 1, orderValue: 'hash' },
  { title: 'Data de Criação', flex: 0.6, orderValue: 'createDate' },
  { title: 'Cliente', flex: 1.2, orderValue: 'customerName' },
  { title: 'Taxa(%)', flex: 0.6, orderValue: 'annualPercentage' },
  { title: 'Exclusão de RV', flex: 0.6, orderValue: 'isRvExclusion' },
  { title: 'Patrimônio líquido', flex: 0.8, orderValue: 'auc' },
  { title: 'Data de contratação', flex: 0.8, orderValue: 'acceptanceDate' },
  { title: 'Ações', flex: 0.5 },
];

export const getFixedFeeColumnFlex = (index: number) => fixedFeeTermsTableHead[index]?.flex || 1;
